// generated by genversion
export var version = '5.1.7';
//# sourceMappingURL=version.js.map